import isPossiblePrototype$1 from './is-possible-prototype.mjs';

var isPossiblePrototype = isPossiblePrototype$1;

var $String = String;
var $TypeError = TypeError;

var aPossiblePrototype = function (argument) {
  if (isPossiblePrototype(argument)) return argument;
  throw new $TypeError("Can't set " + $String(argument) + ' as a prototype');
};

export { aPossiblePrototype as default };
